import * as React from 'react';

import {String} from 'shells/entity/entity-display-values/string';
import {LinkifyTextCustomField} from 'shells/utils/linkify-text-custom-field';

import styles from './cell.module.css';

export const RIGHT_ALIGNED_TYPES = ['number', 'currency', 'integer'] as const;

// Types that should have URLs linkified
const LINKIFIABLE_TYPES = ['string', 'text'];

type Props = {
    value: string | number;
    type: string;
    isHidden?: boolean;
};

export function CellString(props: Props) {
    const {type, value, isHidden} = props;

    const shouldLinkify = LINKIFIABLE_TYPES.includes(type) && typeof value === 'string';

    const renderContent = () => {
        if (shouldLinkify && typeof value === 'string') {
            return <LinkifyTextCustomField text={value} />;
        }

        // @ts-expect-error
        return <String type={props.type} value={value} />;
    };

    return (
        <div
            // @ts-expect-error
            title={isHidden ? undefined : value}
            // @ts-expect-error
            style={RIGHT_ALIGNED_TYPES.includes(type) ? {textAlign: 'right'} : undefined}
            className={styles['cell-content']}
        >
            {renderContent()}
        </div>
    );
}
